import { CaretLeftOutlined, CaretRightOutlined } from "@ant-design/icons";
import React from "react";
import "../css/Pagination.css";

function Pagination({ currentPage, totalPages, onPrevPage, onNextPage }) {
  return (
    <div className="pagination-container">
      <div className="pagination-content">
        Page {currentPage} of {totalPages}
      </div>
      <button
        className="pagination-button"
        onClick={onPrevPage}
        disabled={currentPage === 1}
      >
        <CaretLeftOutlined />
      </button>
      <button
        className="pagination-button"
        onClick={onNextPage}
        disabled={currentPage === totalPages}
      >
        <CaretRightOutlined />
      </button>
    </div>
  );
}

export default Pagination;
